module.exports = __webpack_public_path__ + "static/media/4_nature.9bbd60f2.jpg";